export const MissingValuePlaceholderText = 'NA';
